'use client';

import ActivityIcon from './ActivityIcon.js';
import AwardsIcon from './AwardsIcon.js';
import BonusIcon from './BonusIcon.js';
import CanteenIcon from './CanteenIcon.js';
import HealthcareIcon from './HealthcareIcon.js';
import KindergartenIcon from './KindergartenIcon.js';
import LaptopIcon from './LaptopIcon.js';
import LibraryIcon from './LibraryIcon.js';
import MoreIcon from './MoreIcon.js';
import PaidLeaveIcon from './PaidLeaveIcon.js';
import PhoneIcon from './PhoneIcon.js';
import TrainingIcon from './TrainingIcon.js';
import TransportationIcon from './TransportationIcon.js';
import TravelIcon from './TravelIcon.js';
import VoucherIcon from './VoucherIcon.js';
import PhysicsIcon from './Physics.js';
import WorkingHourIcon from './WorkingHourIcon.js';
import WorkingDayIcon from './WorkingDayIcon.js';
import WorkingTypeIcon from './WorkingTypeIcon.js';

var Benefit = {
    ActivityIcon: ActivityIcon,
    AwardsIcon: AwardsIcon,
    BonusIcon: BonusIcon,
    CanteenIcon: CanteenIcon,
    HealthcareIcon: HealthcareIcon,
    KindergartenIcon: KindergartenIcon,
    LaptopIcon: LaptopIcon,
    LibraryIcon: LibraryIcon,
    MoreIcon: MoreIcon,
    PaidLeaveIcon: PaidLeaveIcon,
    PhoneIcon: PhoneIcon,
    TrainingIcon: TrainingIcon,
    TransportationIcon: TransportationIcon,
    TravelIcon: TravelIcon,
    VoucherIcon: VoucherIcon,
    PhysicsIcon: PhysicsIcon,
    WorkingDayIcon: WorkingDayIcon,
    WorkingHourIcon: WorkingHourIcon,
    WorkingTypeIcon: WorkingTypeIcon
};

export { Benefit as default };
//# sourceMappingURL=index.js.map
